// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"506":"0def0260","787":"532f8445"}[chunkId] + ".chunk.js";
};